import { Box } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { TanstackButtonLink } from '@/components/menu-button'
import { largeTabletAndDown } from '@/styles/media'

import {
  StyledRootLayoutContainerProps,
  StyledRootLayoutHeaderProps,
} from './types'

export const StyledRootLayoutContainer = styled(
  Box
).attrs<StyledRootLayoutContainerProps>({
  $display: 'flex',
  $direction: 'column',
})`
  background-color: ${({ theme, $isDashboardRoute }) =>
    $isDashboardRoute ? theme.colors.background : 'unset'};
  min-height: 100svh;
  ${largeTabletAndDown(css`
    background-color: ${({ theme }) => theme.colors.surface};
  `)}
`

export const OrgImage = styled.img`
  height: 40px;
`

export const StyledRootLayoutHeader = styled(
  Box
).attrs<StyledRootLayoutHeaderProps>({
  $fullWidth: true,
  $px: 8,
  $py: 3,
  $display: 'flex',
  $justify: 'space-between',
  $gap: 4,
})`
  background-color: ${({ theme }) => theme.colors.surface};
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.navbar};
  transition: all 0.2s ease-in-out;

  ${({ $pageScrolled }) =>
    $pageScrolled &&
    css`
      box-shadow:
        0px 2px 4px -2px #3534440f,
        0px 2px 8px -2px #3534441a;
    `}

  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
    gap: ${({ theme }) => theme.space[1]};
  `)}
`

export const StyledRootLayoutFooter = styled(Box).attrs({
  $fullWidth: true,
  $display: 'flex',
  $justify: 'space-between',
  $px: 8,
})`
  height: 50px;
  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
  `)}
`

export const StyledRootLayoutContent = styled(Box).attrs({
  $display: 'flex',
  $fullWidth: true,
  $align: 'normal',
  $justify: 'center',
  $flex: 1,
  $px: 8,
  $pb: 4,
})`
  /* TODO: consolidate page paddings */
  ${largeTabletAndDown(css`
    padding-left: ${({ theme }) => theme.space[4]};
    padding-right: ${({ theme }) => theme.space[4]};
  `)}
`

export const NavMenuList = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  list-style: none;
  padding: 0;
  margin: 0;
`

export const NavMenuItem = styled(TanstackButtonLink).attrs({
  variant: 'flat',
  color: 'tertiary',
})`
  border-radius: ${({ theme }) => theme.radii.rounded};
  &:hover {
    filter: none;
    background-color: ${({ theme }) => theme.colors.background};
  }
  &[data-status='active'] {
    background-color: ${({ theme }) => theme.colors.gray};
    &:hover {
      background-color: ${({ theme }) => theme.colors.gray};
    }
  }
`

export const NavContainer = styled(Box).attrs({
  $flex: 1,
  $display: 'flex',
  $justify: 'flex-start',
  $gap: 8,
})`
  ${largeTabletAndDown(css`
    gap: ${({ theme }) => theme.space[4]};
  `)}
`
